<template>
  <div class="templates">
    <Hero
      class="hero"
      heading="Templates"
      tagline="Some help to get things straight"/>

    <TextBlock title="Some help to get things straight">
      <p>
        These templates are not complete. No template ever
        has done all the work, so please add, collaborate and
        share your slides with co-workers, but also keep each
        other in line so it doesn't get out of hand.
      </p>
    </TextBlock>
    <div class="downloads">
      <DownloadButton class="btn" url="https://seenthis-brand.s3.amazonaws.com/download/templates/power-point-mac.zip">Download PowerPoint template (Mac)</DownloadButton>
      <DownloadButton class="btn" url="https://seenthis-brand.s3.amazonaws.com/download/templates/power-point-windows.zip">Download PowerPoint template (Windows)</DownloadButton>
      <DownloadButton class="btn" url="https://seenthis-brand.s3.amazonaws.com/download/templates/word-template.docx">Download Word template</DownloadButton>
    </div>
    <ViLinks />
  </div>
</template>

<script>
import Hero from '../components/hero.vue';
import TextBlock from '../components/text-block.vue';
import DownloadButton from '../components/download-button.vue';
import ViLinks from '../components/visual-id-links.vue';

export default {
  name: 'Templates',
  components: {
    Hero,
    TextBlock,
    DownloadButton,
    ViLinks,
  },
};
</script>


<style lang="stylus" scoped>
  .downloads
    display: flex
    flex-direction: column
    justify-content: center
    max-width: 80rem
    margin: -4rem auto 8rem auto
    padding: 0 2rem
  .btn
    margin-top: 3rem
</style>
